import { TYPE_COLLECTION } from './input-types';

export const id = 'addressValidationStatus';
export const apiKey = 'ShipToVerificationStatus';
export const type = TYPE_COLLECTION;

export const addressValidationStatus = {
  id,
  apiKey,
  type,
};
